import type { LocaleModule } from "@lit/localize";
import { configureLocalization } from "@lit/localize";

import * as ES from "../generated/locales/es-419";

const ES_TYPED: LocaleModule = ES;

const sourceLocale = "en";
const targetLocales = ["es-419"];

const localizedTemplates = new Map([["es-419", ES_TYPED]]);

export const { getLocale, setLocale } = configureLocalization({
  sourceLocale,
  targetLocales,

  loadLocale: async (locale: string) =>
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    await (Promise.resolve(
      localizedTemplates.get(locale)
    ) as Promise<LocaleModule>),
});
